import { render } from "./CustomerDetails.vue?vue&type=template&id=7de69034&scoped=true"
import script from "./CustomerDetails.vue?vue&type=script&lang=js"
export * from "./CustomerDetails.vue?vue&type=script&lang=js"

import "./CustomerDetails.vue?vue&type=style&index=0&id=7de69034&scoped=true&lang=scss"

import exportComponent from "D:\\CTS_SURAJ\\Tracker Eticket\\Tracker_Eticket\\ui-code\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7de69034"]])

export default __exports__